import { Injectable } from '@angular/core';
import { LoadingController } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class SpinnerService {

  constructor(private loadingController: LoadingController) { }


  /**
   * creates and shows a new loading spinner
   * @param messageString optional, which will default to generic message if no value is provided
   */
  async presentLoading(messageString?) {
    const loading = await this.loadingController.create({
      message: messageString || "Please wait...",
    });
    await loading.present();
  }

  async dismissLoading() {
    await this.loadingController.dismiss().then().catch(() => {
      console.log("No loading spinner to dismiss.");
    });
  }
}
